<template>
    <div class="home">


        <van-overlay :show="show" :lock-scroll="false">

            <div class="wrapper" @click="show = false">
                <img src="../static/back.png" class="back" @click="show = false" alt="">
                <div class="box">
                    <div class="box-words">{{ words }}</div>
                </div>
            </div>
        </van-overlay>


        <van-overlay :show="show1">

            <div class="flower-box" @click="show1 = false">
                <img src="../static/flower.png" class="flower" alt="">
                <div class="num">{{ num }}</div>
            </div>
        </van-overlay>
        <div class="homebg t1" v-show="thepage == 1">
            <img src="../static/home.png" class="bg" alt="">
        </div>
        <div class="homebg t2" v-show="thepage == 2">
            <img src="../static/bg.png" class="bg" alt="">
            <div class="words">
                <p> 1930年8月27日，一个黑暗的日子，位于杭州的浙江陆军监狱，看着狱友一个个被带走，曾任兰溪农军游击队总指挥的裘古怀给党写下遗书：</p>
                <p>“壮大我们的革命武装力量，争取胜利吧！胜利的时候，请你们不要忘记我们！”</p>
                <p>落笔不久，26岁的他从容就义。</p>
                <p>金华烈士纪念馆前的英烈墙上，刻着2300多位烈士的名字。每一个名字的背后，都有一颗赤热而坚定的心，一个像山峰般伟岸的身影。</p>
                <p>今又清明，桃红柳绿，大江南北共沐美好春光，齐享和平盛世。</p>
                <p>今天，让我们重温烈士生前的铮铮话语，或慷慨，或决绝，或愤怒，或温情。</p>
                <p>我们念之于口，烈士百十年来的呐喊如在耳畔；我们铭记于心，方才不负烈士的殷殷期望——你们的英雄过往，你们的豪言壮语，不管过去多久，我们都不会忘记！</p>
                <p>致敬英烈，在你们出发的地方，在你们战斗的地方，我们会勇毅前行。</p>
            </div>
        </div>
        <div class="homebg t3" v-show="thepage == 3" @click="showwords(1)">
            <img src="../static/p1.png" class="bg" alt="">
            <img src="../static/hands.png" class="hands" alt="">
        </div>
        <div class="homebg t4" v-show="thepage == 4" @click="showwords(2)">
            <img src="../static/p2.png" class="bg" alt="">
            <img src="../static/hands.png" class="hands" alt="">
        </div>
        <div class="homebg t5" v-show="thepage == 5">
            <img src="../static/p3.png" class="bg" @click="showwords(3)" alt="">
        </div>
        <div class="homebg t6" v-show="thepage == 6">
            <img src="../static/p4.png" class="bg" @click="showwords(4)" alt="">
        </div>
        <div class="homebg t7" v-show="thepage == 7">
            <img src="../static/p5.png" class="bg" @click="showwords(5)" alt="">
        </div>
        <div class="homebg t8" v-show="thepage == 8">
            <img src="../static/p6.png" class="bg" @click="showwords(6)" alt="">
        </div>
        <div class="homebg t9" v-show="thepage == 9">
            <img src="../static/p7.png" class="bg" @click="showwords(7)" alt="">
        </div>
        <div class="homebg t10" v-show="thepage == 10">
            <img src="../static/p8.png" class="bg" @click="showwords(8)" alt="">
        </div>
        <div class="homebg t11" v-show="thepage == 11">
            <img src="../static/p9.png" class="bg" @click="showwords(9)" alt="">
        </div>
        <div class="homebg " v-show="thepage == 12">
            <img src="../static/p10.png" class="bg" alt="">
            <!-- <img src="../static/end.png" class="end" alt=""> -->
            <img src="../static/endbut.png" class="endbut" @click="showflower" alt="">
        </div>
        <van-icon name="arrow-left" class="icon-left" @click="toback" />
        <van-icon name="arrow" class="icon-right" @click="tonext" />
        <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
        <audio id="audio" loop="loop" autoplay='autoplay' preload="auto" src="../static/bgm.mp3"></audio>
    </div>
</template>

<script>
export default {
    data() {
        return {
            thepage: 1,
            show: false,
            words: '',
            music: false,
            show1: false,
            num: 0

        }
    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                audio.volume = 0.5;
                audio.play();
            }
        },
        tonext() {
            if (this.thepage == 1 && this.music == false) {
                let audio = document.getElementById("audio");
                this.music = true;
                audio.volume = 0.5;
                audio.play();
            }
            if (this.thepage < 12) {
                this.thepage++
            }


        },
        showflower() {
            this.show1 = true


            console.log(333, window.localStorage.getItem("num"));
            if (window.localStorage.getItem("num") == null) {
                this.num = 12684

            } else {
                this.num = window.localStorage.getItem("num")
            }

            var tnum = Number(this.num) + Math.floor(Math.random() * 30) + 1;
            window.localStorage.setItem("num", tnum)
        },
        toback() {
            if (this.thepage > 1) {
                this.thepage--
            }

        },
        showwords(a) {
            if (a == 1) {
                this.words = '武义县三港乡石浦村，山清水秀，被称为“宣平第一敢死士”的詹蒙，就从这里走出。1911年，詹蒙在南京陆军第四中学加入中国同盟会。武昌起义爆发后，詹蒙积极响应革命，暗杀保皇派头目张勋，事败后率同学驰援武昌，被编入南洋混成独立队，任副队长，指挥作战。1911年11月21日，詹蒙参与汉口保卫战，左耳中弹后，战友想帮他包扎，他说：“今日死且不暇计，何恤一耳？”继续投入战斗。最后，头部中弹，壮烈牺牲，年仅19岁。'
            } else if (a == 2) {
                this.words = '作为中国新闻理论的开拓者、奠基人，东阳籍的邵飘萍只走过40年的人生旅程，却在中国革命史上留下浓墨重彩的一笔，无愧于“杰出的无产阶级新闻战士”称号。1918年，邵飘萍在北京创办《京报》，揭露罪恶，唤醒民众。1919年5月3日，他鼓舞北大学生救亡图存，次日，载入史册的五四运动爆发。1926年，由于揭露张作霖的黑暗统治，邵飘萍处境危险，他没有选择躲避，说了一句振聋发聩的话：“现在别人不能讲话，所以我不能跑。我要写，我要说，死也要讲！我舍生取义，死不择音为人民，无遗憾！”当年4月26日，邵飘萍被奉系军阀杀害。“飘萍一支笔，抵过十万军”，邵飘萍牺牲近百年后，这句话还在激励着众多新闻从业者。'
            } else if (a == 3) {
                this.words = '东阳横店镇良渡村，金佛庄烈士纪念馆庄严肃穆。了解完金佛庄短暂辉煌的一生，参观者们肃然起敬。他原本是一名成绩优异的学生，身逢乱世，选择投笔从戎，考入保定陆军军官学校，参加五四运动，是浙江省最早的中共组织——中共杭州小组的3位成员之一。1924年参加黄埔军校的创建工作，参加过两次东征和北伐，被誉为“北伐名将”。1926年，有感时局危险，金佛庄在广东写下《传略自述》，其中一句话道出了他的革命初心：“为国家人才乎！为世界人才乎！从军乎！研究科学乎！眼见国家将亡，不应徒作书生，默默以终也！”同年12月12日，金佛庄在南京被军阀孙传芳部杀害，是第一位牺牲在南京雨花台的中共烈士，也是黄埔军校最早牺牲的中共党员之一。'
            } else if (a == 4) {
                this.words = '徐英原名胡连，武义水碓后村人，1925年冬加入中国共产党。1927年任中共武义县委书记，领导永康、武义两县于1928年10月10日举行农民武装暴动。1929年1月，徐英任浙江省委书记，后到宁波领导革命斗争，建立支部，发展党员，当年12月被捕，关押于浙江陆军监狱。在狱中，他继续领导斗争活动，提出“法庭是战场，监狱是熔炉”，把上级党称为“外祖母”，把狱中的党组织称为“母亲”。1930年8月27日，19名在押的共产党人被接连杀害，史称“八二七”大屠杀。当第一批同志牺牲时，徐英与全牢房的难友握手告别，他大声说：“同志们，永别了。你们不要为我悲伤，不要为我流泪，该为我而努力，该为我而奋斗！”当徐英和一位位烈士倒下时，《国际歌》和《囚徒歌》响彻整座监狱。'
            } else if (a == 5) {
                this.words = '在中国现代文学史上，湖畔诗社是最早的新诗团体。4位创办人中，有一位来自武义的青年，他就是潘漠华。诗歌让潘漠华能够痛斥腐朽歌颂光明，马克思主义让他从青年诗人成长为革命斗士。潘漠华参加过北伐军，还辗转开封、厦门、沧州等地开展革命运动。1930年参加中国左翼作家联盟成立大会，担任北方左联筹委会负责人，创办进步刊物，宣传革命思想。1933年，第四次被捕，1934年12月24日，被敌人灌以滚烫开水而惨烈牺牲，年仅32岁。“我想在将天明时我的生命，再吹起我嘹亮的画角，重招拢满天的星，重画出满天的云彩。我想停唱我底挽歌，想在我底挽歌内，完全消失去我自己，也完全再生我自己。”在牺牲的12年前，潘漠华已通过短诗《再生》表达过他的信仰，英烈没有离开，只是选择了再生。'
            } else if (a == 6) {
                this.words = '在东阳，只有一位烈士同时得到毛泽东和周恩来的题词，他就是吴复夏。1913年，吴复夏出生于南市街道西坞村，“九·一八”事变爆发后，冒名报考中央航空学校。1936年，母亲带着两个兄弟来到中央航空学校，与他商量分家立业事宜，他这样回复：“其一对于婚姻，我是随时准备上战场的人，不要害了别人。再一对于家业，我若胜利荣归，我的家产将用以建学校；我若战死沙场，我的抚恤金用以建学校。”毕业以后，吴复夏曾任国民革命军空军第一大队少尉侦察机驾驶员、三中队轰炸手。1938年3月16日，吴复夏和战友们奉命轰炸被日军占领的杭州笕桥机场，炸毁敌机11架、仓库4处，炸死日军20余人。返航时突遭敌机截击，吴复夏和射手虞为民壮烈牺牲。家人拿出他的万元抚恤金，又捐出15亩地，筹建复夏小学。今天，复夏小学书声琅琅，每一个学生都铭记着吴复夏的英雄事迹。'
            } else if (a == 7) {
                this.words = '雷烨原名项金土，学名项俊文，军名雷烨。1914年出生于金华孝顺镇后项村，父亲早逝，家庭贫苦。抗战爆发后，雷烨心向革命，将弟妹作了安排，典卖家屋，奔赴延安，进入抗日军政大学学习并加入中国共产党，赴晋察冀边区前线记者团。顶着战火，雷烨用摄影与文字记录日寇犯下的“潘家峪大惨案”以及制造“人圈”、奴役人民等罪行，此外还报道我国军民的对敌斗争成果，鼓舞军心民心。“冀东是谁的？不是日寇的，是我们的！我中华民族这一柄复仇复土之剑，必将愈磨愈利，直指黑水白山，直指日寇心脉！”雷烨用激昂的文字向世界宣布：冀东是我们的，侵犯我疆土者，必将血债血偿。1943年4月19日，雷烨在动员乡亲们转移后，自己错过了转移时机，他用手枪对付日军，砸碎相机，把最后一颗子弹留给自己。'
            } else if (a == 8) {
                this.words = '在金华烈士纪念馆，陈列着唯一一位长眠在非洲的烈士的资料，他叫金尔银，义乌人。1955年，金尔银参加中国人民解放军，3年后复员，进入浙江省工业设备安装集团有限公司当起重工。1959年，几内亚共和国成为第一个与中国建交的撒哈拉以南的非洲国家。1972年9月，我国援建几内亚的纪念碑工程。金尔银临行前对家人说：“等我回来，咱们全家就去照张相。”当时12岁的儿子目送他离开，不料竟是永别。1973年3月14日，工地上突发意外，一根高压线突然断裂，砸向一名几内亚工人，金尔银使出全身力气将对方推到一边，自己壮烈牺牲。时任几内亚总统赛吉·杜尔给周恩来发送电报：“这位中国专家不仅从广义上说为中几友谊而死，而且是直接为抢救一名几内亚工人而死，我们应该加倍感激他。”'
            } else if (a == 9) {
                this.words = '清明将至，金华城南桥边的孟祥斌雕像边，和往年一样又是菊花簇拥。十几年过去，金华人依然记得2007年一个人感动一座城的壮举。孟祥斌是山东齐河人，1997年入伍，曾任驻金96164部队机要科副连职参谋。2007年11月30日，他请假陪同从外省来探亲的妻女，路过城南桥时，一名情感受挫的女青年跳江轻生。不顾江水冰冷，不顾桥离水面十几米，孟祥斌要跳桥救人。好心人拉他，妻子劝他从岸边游过去，他说：“来不及了，我会游泳。”他游到女青年身边，奋力托起她，在另一军人的助力下，女青年获救，孟祥斌却沉入江底。3岁的女儿从此失去父亲，八婺大地多了一位英烈，一座城的人切身体会了什么是舍己救人，什么是感动中国。'
            }
            this.show = true
        }
    },
}
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    position: relative;

    .back {
        width: 80px;
        position: absolute;
        top: 50px;
        left: 0;
    }

    .music {
        position: fixed;
        top: 15px;
        right: 15px;
        width: 40px;
        transform: rotate(250deg);

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .flower-box{
        position: relative;
        height: 100%;
        z-index: 5;
        .flower {
            position: absolute;
            top: 194px;
            left: 50%;
            margin-left: -150px;
            width: 300px;

        }

        .num {
            position: absolute;
            width: 100px;
            height: 35px;

            font-size: 20px;
            top: 450px;
            left: 120px;
            line-height: 35px;
            text-align: center;
            color: #fff;
            font-weight: 800;
        }
    }

    .wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 4;

     

        .box {

            width: 300px;
            height: 500px;
            background: url('../static/box.png') no-repeat;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 40px 30px;
            left: 50%;
            font-size: 16px;
            top: 180px;
            font-weight: 800;
            text-align: justify;
            text-indent: 2em;

            .box-words {
                height: 400px;
                overflow: hidden;
                overflow-y: scroll;
            }

        }
    }


    .icon-left {
        font-size: 30px;
        background-color: #f6f6f66e;
        border-radius: 50%;
        position: fixed;
        color: #817e7e;
        height: 40px;
        width: 40px;
        text-align: center;
        line-height: 40px;
        left: 20px;
        top: 200px;

    }

    .icon-right {
        font-size: 30px;
        background-color: #f6f6f66e;
        border-radius: 50%;
        position: fixed;
        color: #817e7e;
        height: 40px;
        width: 40px;
        text-align: center;
        line-height: 40px;
        right: 20px;
        top: 200px;

    }

    .homebg {
        width: 100%;
        position: absolute;

        .bg {
            width: 375px;
            max-height: 750px;
            display: block;
        }

        .hands {
            position: absolute;
            width: 100px;
            top: 360px;
            right: 90px;
            animation: hands-ani 1s linear infinite;

            @keyframes hands-ani {
                0% {

                    top: 360px;
                    right: 90px;
                }

                50% {
                    top: 370px;
                    right: 85px;
                }

                100% {
                    top: 360px;
                    right: 90px;
                }
            }
        }

        .words {
            position: absolute;
            width: 300px;
            height: 500px;
            left: 50%;
            margin-left: -150px;
            font-size: 16px;
            top: 180px;
            font-weight: 800;
            text-align: justify;
            text-indent: 2em;

        }

        .end {
            width: 100%;
            position: absolute;
            top: 50px;
            left: 0;
        }

        .endbut {
            width: 240px;
            position: absolute;
            left: 50%;
            margin-left: -120px;
            top: 600px;
            animation: but-ani 1s linear infinite;

            @keyframes but-ani {
                0% {

                    width: 240px;
                    margin-left: -120px;
                }

                50% {
                    width: 220px;
                    margin-left: -110px;
                }

                100% {
                    width: 240px;
                    margin-left: -120px;
                }
            }
        }
    }


}
</style>